<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Transferências</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <h3 class="tituloForm">Tipo de Transferência</h3>
        <vs-row>
          <vs-col>
            <vs-select
              v-model="sameBranchAndShift"
              :name="sameBranchAndShift"
              danger-text="Campo obrigatório."
              noData="Nenhum dado encontrado"
              width="100%"
              autocomplete
            >
              <vs-select-item value="1" text="Mesma Filial e Turno" selected />
              <!--<vs-select-item value="0" text="Troca de Turno ou Filial" /> -->
            </vs-select>
          </vs-col>
        </vs-row>
        <h3 class="tituloForm">Pesquisar Aluno</h3>
        <vs-row vs-w="12">
          <vs-col vs-lg="8" vs-xs="12">
            <vs-input
              name="ra"
              type="number"
              v-model="ra"
              placeholder="Digite o RA do Aluno"
              @keyup.enter="searchRA(ra)"
            />
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12">
            <vs-button icon="search" style="width: 100%;" @click="searchRA(ra)" :disabled="!ra.length">
              Pesquisar
            </vs-button>
          </vs-col>
          <vs-divider/>
          <vs-row v-for="course in coursesList" :key="course.IDHABILITACAOFILIAL">
            <vs-card style="box-shadow: 0px 0px 2px 1px #888888;" v-if="course.RA != null">
              <div slot="header">
                <h4>{{ course.CURSO }}</h4>
              </div>
              <vs-row>
                <p>
                  <strong> {{ course.ALUNO }} </strong><br />
                  {{ course.TURNO }}, QI {{ course.CODFILIAL }}<br />
                  Período Letivo: {{ course.CODPERLET }}
                </p>
              </vs-row>
              <vs-row vs-w="12" v-if="course.INADIMPLENTE == 1">
                <p>
                  <strong class="danger"
                    >* Aluno está indadimplente neste curso, não é possível
                    realizar movimentação acadêmica.
                  </strong>
                </p>
              </vs-row>
              <vs-col>
                <vs-button
                  style="width: 100%; margin: 5px 0 2.5px 0;"
                  icon="local_offer"
                  @click="selectCourse(course)"
                  v-if="course.INADIMPLENTE == 0"
                >
                  Ver Disciplinas
                </vs-button>
              </vs-col>
            </vs-card>
            <vs-card v-else>
              <div slot="header">
                Aluno não encontrado, tente digitar outro RA.
              </div>
            </vs-card>
          </vs-row>
        </vs-row>
        <vs-row>
          <vs-alert
            title="Não há ofertas"
            class="margin"
            color="danger"
            v-if="error"
          >
            {{ error }}
          </vs-alert>
        </vs-row>
      </section>
    </div>
  </div>
</template>

<script>
import AcademicMovement from "../services/academicMovements";
import moment from "moment";
import { clearStepsInformation, updateStepsInformation } from "../helpers";

export default {
  name: "TransfersStep1",
  data: () => ({
    ra: "",
    coursesList: [],
    error: null,
    sameBranchAndShift: 1,
  }),

  filters: {
    moment: function (date) {
      moment.locale("pt-br");
      return moment(date).format("DD/MM/YYYY");
    },
  },

  created() {
    clearStepsInformation();
  },

  methods: {
    async selectCourse(course) {
      this.error = null;
      let courseTransfer = course;
      let offersToTransfer = [];
      courseTransfer.sameBranchAndShift = this.sameBranchAndShift;
      updateStepsInformation({ courseTransfer });

      await new AcademicMovement()
        .getOffer(
          courseTransfer.RA,
          courseTransfer.IDHABILITACAOFILIAL,
          courseTransfer.sameBranchAndShift
        )
        .then(({ data }) => {
          offersToTransfer = Array.isArray(data) ? data : [data];
        })
        .catch(({ error }) => {
          this.error = error;
        });

      updateStepsInformation({ offersToTransfer });

      //se mesmo turno e tem oferta, segue para passo 2
      if (offersToTransfer.length > 0 && courseTransfer.sameBranchAndShift == 1)
        this.$router.push("/transfersStep2");
      else if (
        offersToTransfer.length > 0 &&
        courseTransfer.sameBranchAndShift == 0
      )
        //segue para lista de ofertas
        console.log("lista de ofertas");
      else
        this.error =
          "Não foram encontradas ofertas válidas para transferência.";
    },

    searchRA(ra) {
      this.$vs.loading({
        color: "danger",
      });

      new AcademicMovement()
        .getCoursesByRA(ra)
        .then(({ data }) => {
          this.coursesList = Array.isArray(data) ? data : [data];
        })
        .catch(({ error }) => {
          this.error = error;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style>
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
.danger {
  color: red;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
</style>
